import { useAuth, useIsOffline } from '@oneblink/apps-react'
import profileImage from './profile.png'
import LogoutButton from '../../components/Auth/LogoutButton'
import { CenteredPageContent } from '../../components/LayoutComponents'
import { H1, H2 } from '../../components/TextComponents'

function UserProfileComponent({
  userFriendlyName,
}: {
  userFriendlyName: string
}) {
  return (
    <>
      <img src={profileImage} alt="profile" />
      <H2>{userFriendlyName}</H2>
    </>
  )
}

export default function ProfileScene() {
  const { userFriendlyName, userProfile, isLoggedIn } = useAuth()
  const isOffline = useIsOffline()

  return (
    <CenteredPageContent>
      <H1>Profile</H1>
      {isLoggedIn && userProfile && (
        <>
          <UserProfileComponent
            userFriendlyName={userFriendlyName || userProfile.username || ''}
          />
          {!isOffline && (
            <>
              <LogoutButton />
            </>
          )}
        </>
      )}
    </CenteredPageContent>
  )
}
